// 작업 프로세스 4단계. 내부세차 먼저 진행 루틴 확정(2026-06-17) —
// STEP 2 실내 클리닝 → STEP 3 외부 클리닝 순서.
// desc는 여러 줄(문자열 배열)로, ProcessFlow가 줄 단위로 렌더한다.
export const PROCESS_STEPS = [
  { id: 1, icon: 'ClipboardCheck', label: '접수', step: 'STEP 1', desc: ['차량 상태 확인', '시공 서비스 선택'] },
  { id: 2, icon: 'Sparkles', label: '실내 클리닝', step: 'STEP 2', desc: ['진공 청소', '실내 스팀 세정', '디테일 브러쉬 세정', '(모든 메뉴 기본 포함)'] },
  { id: 3, icon: 'Wind', label: '외부 클리닝', step: 'STEP 3', desc: ['고온 스팀 초벌 세정', '친환경 약품 세정', '고광택 왁스 시공', '(모든 메뉴 기본 포함)'] },
  { id: 4, icon: 'CircleCheck', label: '마감 검수', step: 'STEP 4', desc: ['최종 점검', '고객 인도'] },
];
